// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-criminal-grid-bankruptcy .settingsContainer {
  display: flex;
  flex-direction: row;
  padding-left: 150px;
}
app-criminal-grid-bankruptcy .settingsContainer .radio-row {
  display: inline-flex;
  flex-direction: column !important;
}
app-criminal-grid-bankruptcy .settingsContainer .radio-row .radio-faux-label {
  font-weight: 600;
  padding-left: 15px;
  padding-bottom: 10px;
}
app-criminal-grid-bankruptcy .settingsContainer .radio-row .radio-faux-label-text {
  font-weight: 600;
}
app-criminal-grid-bankruptcy .settingsContainer .defaultSettingContainer {
  flex: 0 1 180px;
}
app-criminal-grid-bankruptcy .settingsContainer .offsenseNameContainer {
  flex: 0 1 40%;
  font-weight: 600;
}
app-criminal-grid-bankruptcy .settingsContainer .howManyAllowedContainer {
  flex: 0 1 280px;
}
app-criminal-grid-bankruptcy .settingsContainer .howManyAllowedContainer .mat-radio-button {
  padding-right: 10px;
}
app-criminal-grid-bankruptcy .settingsContainer .howManyAllowedContainer .mat-radio-button .mat-radio-label {
  font-weight: 600;
}
app-criminal-grid-bankruptcy .settingsContainer .howManyAllowedContainer .mat-radio-label {
  margin-bottom: 0 !important;
}
app-criminal-grid-bankruptcy .settingsContainer .howLongContainer {
  flex: 0 1 190px;
}
app-criminal-grid-bankruptcy .settingsContainer .howLongContainer .howLongInput {
  width: 50px;
}
app-criminal-grid-bankruptcy .settingsContainer .howLongContainer .yearsLabel {
  font-weight: 600;
  padding-left: 10px;
}
app-criminal-grid-bankruptcy .settingsContainer .decisionContainer {
  flex: 0 1 270px;
}
app-criminal-grid-bankruptcy .settingsContainer .decisionContainer .radio-row {
  padding-right: 15px;
  text-align: center;
}
app-criminal-grid-bankruptcy .settingsContainer .buttonContainer {
  flex: 0 1 70px;
}
app-criminal-grid-bankruptcy .settingsContainer .buttonContainer .propertyOverrideLabel {
  font-size: 11px;
}
app-criminal-grid-bankruptcy .settingsContainer .buttonContainer .saveButton {
  background-color: green;
}
app-criminal-grid-bankruptcy .masterCrimeContainer {
  display: flex;
  flex-direction: column;
}
app-criminal-grid-bankruptcy .masterCrimeContainer .settingsReadout {
  padding: 5px;
  background-color: #f7ebef;
  margin-right: 50px;
}
app-criminal-grid-bankruptcy .masterCrimeContainer .settingsReadout .description {
  font-weight: bold;
}
app-criminal-grid-bankruptcy .masterCrimeContainer .settingsReadout .highlightedBlock {
  padding-left: 5px;
  padding-right: 5px;
  color: blue;
  text-decoration: underline;
  text-transform: capitalize;
}
app-criminal-grid-bankruptcy .propertyOverrideContainer {
  background-color: aquamarine;
  border: none;
  margin-top: 12px;
  padding-top: 16px;
  padding-bottom: 0px;
}
app-criminal-grid-bankruptcy .propertyOverrideContainer .buttonContainer {
  flex: 0 1 70px;
}
app-criminal-grid-bankruptcy .propertyOverrideContainer .buttonContainer .propertyOverrideSaveButton {
  background-color: green;
}
app-criminal-grid-bankruptcy .propertyOverrideContainer .buttonContainer .propertyOverrideDeleteButton {
  background-color: red;
}
app-criminal-grid-bankruptcy .propertyOverrideContainerResults {
  background-color: aquamarine;
  padding-bottom: 7px;
}
app-criminal-grid-bankruptcy .propertyOverrideContainerResults .settingsReadout {
  padding: 5px;
  background-color: #f7ebef;
}
app-criminal-grid-bankruptcy .propertyOverrideContainerResults .settingsReadout .description {
  font-weight: bold;
}
app-criminal-grid-bankruptcy .propertyOverrideContainerResults .settingsReadout .highlightedBlock {
  padding-left: 5px;
  padding-right: 5px;
  color: blue;
  text-decoration: underline;
  text-transform: capitalize;
}
app-criminal-grid-bankruptcy .mat-radio-label {
  flex-direction: column;
}
app-criminal-grid-bankruptcy .mat-radio-label .mat-radio-label-content {
  padding: 10px;
}
app-criminal-grid-bankruptcy .settingsContainer {
  border-top: 1px solid;
  padding-top: 20px;
  padding-bottom: 2px;
}
app-criminal-grid-bankruptcy .mat-tab-label {
  background-color: #e6e4e6;
  width: 50%;
}
app-criminal-grid-bankruptcy .gridHeaderContainer {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 150px;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .headerContainer {
  font-weight: 600;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .defaultSettingHeader {
  flex: 0 1 180px;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .offsenseNameHeader {
  flex: 0 1 40%;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .howManyAllowedHeader {
  flex: 0 1 280px;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .howLongHeader {
  flex: 0 1 190px;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .decisionHeader {
  flex: 0 1 270px;
}
app-criminal-grid-bankruptcy .gridHeaderContainer .buttonHeader {
  flex: 0 1 70px;
}
app-criminal-grid-bankruptcy .button-row {
  position: static !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/criminal-grid-bankruptcy/criminal-grid-bankruptcy.component.less"],"names":[],"mappings":"AAAA;EAGI,aAAA;EACA,mBAAA;EAEA,mBAAA;AAFJ;AAJA;EASM,oBAAA;EACA,iCAAA;AAFN;AARA;EAaQ,gBAAA;EACA,kBAAA;EACA,oBAAA;AAFR;AAbA;EAkBQ,gBAAA;AAFR;AAhBA;EAuBM,eAAA;AAJN;AAnBA;EA4BM,aAAA;EACA,gBAAA;AANN;AAvBA;EAiCM,eAAA;AAPN;AA1BA;EAoCQ,mBAAA;AAPR;AA7BA;EAuCU,gBAAA;AAPV;AAhCA;EA4CQ,2BAAA;AATR;AAnCA;EAiDM,eAAA;AAXN;AAtCA;EAoDQ,WAAA;AAXR;AAzCA;EAwDQ,gBAAA;EACA,kBAAA;AAZR;AA7CA;EA8DM,eAAA;AAdN;AAhDA;EAiEQ,mBAAA;EACA,kBAAA;AAdR;AApDA;EA+EM,cAAA;AAxBN;AAvDA;EAkFQ,eAAA;AAxBR;AA1DA;EAsFQ,uBAAA;AAzBR;AA7DA;EA4FI,aAAA;EACA,sBAAA;AA5BJ;AAjEA;EA+FM,YAAA;EACA,yBAAA;EACA,kBAAA;AA3BN;AAtEA;EAoGQ,iBAAA;AA3BR;AA8BM;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AA5BR;AAhFA;EAkHI,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA/BJ;AAvFA;EA2HM,cAAA;AAjCN;AA1FA;EA8HQ,uBAAA;AAjCR;AA7FA;EAkIQ,qBAAA;AAlCR;AAuCE;EAEE,4BAAA;EACA,mBAAA;AAtCJ;AAwCI;EACE,YAAA;EACA,yBAAA;AAtCN;AAoCI;EAKI,iBAAA;AAtCR;AAyCM;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AAvCR;AAlHA;EAiKI,sBAAA;AA5CJ;AArHA;EAoKM,aAAA;AA5CN;AAxHA;EA2KI,qBAAA;EAGA,iBAAA;EACA,mBAAA;AAlDJ;AA7HA;EAoLI,yBAAA;EACA,UAAA;AApDJ;AAjIA;EAyLI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AArDJ;AAxIA;EAgMM,gBAAA;AArDN;AA3IA;EAoMM,eAAA;AAtDN;AA9IA;EAyMM,aAAA;AAxDN;AAjJA;EA6MM,eAAA;AAzDN;AApJA;EAiNM,eAAA;AA1DN;AAvJA;EAqNM,eAAA;AA3DN;AA1JA;EAyNM,cAAA;AA5DN;AA7JA;EA8NI,2BAAA;AA9DJ","sourcesContent":["app-criminal-grid-bankruptcy {\n\n  .settingsContainer {\n    display: flex;\n    flex-direction: row;\n\n    padding-left: 150px;\n\n    .radio-row {\n      display: inline-flex;\n      flex-direction: column !important;\n      \n      .radio-faux-label {\n        font-weight: 600;\n        padding-left: 15px;\n        padding-bottom: 10px;\n      }\n      .radio-faux-label-text {\n        font-weight: 600;\n      }\n    }\n\n    .defaultSettingContainer {\n      flex: 0 1 180px;\n    }\n\n    .offsenseNameContainer {\n      // flex: 1;\n      flex: 0 1 40%;\n      font-weight: 600;\n    }\n\n    .howManyAllowedContainer {\n      flex: 0 1 280px;\n\n      .mat-radio-button {\n        padding-right: 10px;\n\n        .mat-radio-label {\n          font-weight: 600;\n        }\n      }\n\n      .mat-radio-label {\n        margin-bottom: 0 !important;\n      }\n    }\n\n    .howLongContainer {\n      flex: 0 1 190px;\n\n      .howLongInput {\n        width: 50px;\n      }\n\n      .yearsLabel {\n        font-weight: 600;\n        padding-left: 10px;\n      }\n    }\n\n    .decisionContainer {\n      flex: 0 1 270px;\n\n      .radio-row {\n        padding-right: 15px; \n        text-align: center;\n      }\n\n      // .mat-radio-button {\n      //   padding-right: 12px;\n\n      //   .mat-radio-label {\n      //     font-weight: 600;\n      //   }\n      // }\n    }\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideLabel {\n        font-size: 11px;\n      }\n\n      .saveButton {\n        background-color: green;\n      }\n    }\n  }\n\n  .masterCrimeContainer {\n    display: flex;\n    flex-direction: column;\n    .settingsReadout {\n      padding: 5px;\n      background-color: #f7ebef;\n      margin-right: 50px;\n\n      .description {\n        font-weight: bold;\n      }\n\n      & .highlightedBlock {\n        padding-left: 5px;\n        padding-right: 5px;\n        color: blue;\n        text-decoration: underline;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n  .propertyOverrideContainer {\n    background-color: aquamarine;\n    border: none;\n    margin-top: 12px;\n    padding-top: 16px;\n    padding-bottom: 0px;\n    // margin-left: 20px;\n    // padding-left: 20px;\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideSaveButton {\n        background-color: green;\n      }\n\n      .propertyOverrideDeleteButton {\n        background-color: red;\n      }\n    }\n  }\n\n  & .propertyOverrideContainerResults {\n\n    background-color: aquamarine;\n    padding-bottom: 7px;\n\n    & .settingsReadout {\n      padding: 5px;\n      background-color: #f7ebef;\n\n      .description {\n        font-weight: bold;\n      }\n\n      & .highlightedBlock {\n        padding-left: 5px;\n        padding-right: 5px;\n        color: blue;\n        text-decoration: underline;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n\n  // Put the radio button labels underneath\n  .mat-radio-label {\n    flex-direction: column;\n\n    .mat-radio-label-content {\n      padding: 10px;\n    }\n  }\n\n\n\n  .settingsContainer {\n    border-top: 1px solid;\n    // border-bottom: 1px solid;\n\n    padding-top: 20px;\n    padding-bottom: 2px;\n\n  }\n\n  .mat-tab-label {\n    background-color: #e6e4e6;\n    width: 50%;\n  }\n\n  .gridHeaderContainer {\n    display: flex;\n    flex-direction: row;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 150px;\n\n    .headerContainer {\n      font-weight: 600;\n    }\n\n    .defaultSettingHeader {\n      flex: 0 1 180px;\n    }\n\n    .offsenseNameHeader {\n      // flex: 1;\n      flex: 0 1 40%;\n    }\n\n    .howManyAllowedHeader {\n      flex: 0 1 280px;\n    }\n\n    .howLongHeader {\n      flex: 0 1 190px;\n    }\n\n    .decisionHeader {\n      flex: 0 1 270px;\n    }\n\n    .buttonHeader {\n      flex: 0 1 70px;\n    }\n  }\n\n  .button-row {\n    position: static !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
